

    const isAppikonProductPage = null != decodeURIComponent(window.location.pathname).match(/\/products\/(([a-zA-Z0-9]|[\-\.\_\~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\ud83c\ud83d\ud83e][\ud000-\udfff]){1,})\/?/);
    const isAppikonCartPage = window.location.pathname === '/cart';

    function getUrlParam(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }

    const testOfferParam = getUrlParam('shopacadoTestToken');
    const testOfferName = getUrlParam('shopacadoTestName');

    ! function (window, document) {
        "use strict";

        function setCookie(t, e, n) {
            var o = new Date;
            o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3);
            var i = "expires=" + o.toUTCString();
            document.cookie = t + "=" + e + "; " + i + "; path=/;"
        }

        function setCookieMinutes(t, e, m) {
            var o = new Date;
            o.setTime(o.getTime() + m * 60000);
            var i = "expires=" + o.toUTCString();
            document.cookie = t + "=" + e + "; " + i + "; path=/;"
        }

        function setCookieSession(t, e) {
            document.cookie = t + "=" + e + "; path=/;"
        }

        if (testOfferParam) {
            setCookieSession('shopacado-test-offer-token', testOfferParam);
            setCookieSession('shopacado-test-offer-name', testOfferName);

            var uri = window.location.toString();
            if (uri.indexOf("?") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("?"));
                window.history.replaceState({}, document.title, clean_uri);
            }
        }

        function deleteCookie(t) {
            var o = new Date;
            o.setTime(o.getTime() - 1000);
            var i = "expires=" + o.toUTCString();
            document.cookie = t + "=; " + i + "; path=/;"
        }

        function getCookie(t) {
            for (var e = t + "=", n = document.cookie.split(";"), o = 0; o < n.length; o++) {
                for (var i = n[o];
                     " " == i.charAt(0);) i = i.substring(1);
                if (0 == i.indexOf(e)) return i.substring(e.length, i.length)
            }
            return ""
        }

        function isMobileBrowser() {
            var t = !1;
            try {
                (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) && (t = !0)
            } catch (e) {}
            return t
        }

        function reqJquery(t) {
            if ("undefined" == typeof jQuery || !jQuery || 1 === parseInt(jQuery.fn.jquery) && parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 10) {
                var e = document.getElementsByTagName("head")[0],
                        n = document.createElement("script");
                n.src = ("https:" == document.location.protocol ? "https://" : "http://") + "ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js", n.type = "text/javascript", n.onload = n.onreadystatechange = function () {
                    n.readyState ? "complete" !== n.readyState && "loaded" !== n.readyState || (n.onreadystatechange = null, t(jQuery.noConflict(!0))) : t(jQuery.noConflict(!0))
                }, e.appendChild(n)
            } else t(jQuery)
        }

        function addGlobalStyle(t) {
            try {
                var e = document.head || document.getElementsByTagName("head")[0],
                        n = document.createElement("style");
                n.innerHTML = t, n.type = "text/css", e.appendChild(n)
            } catch (o) {}
        }

        if (-1 !== document.location.search.indexOf("clear_cookies=1")) {
            setCookie("adp-skip-ids", "");
            setCookie("cart", "");
        }

        reqJquery(function ($) {
            checkForTestOffer();

            function reloadCurrency() {
                "object" == typeof Currency && "object" == typeof Currency.moneyFormats && "function" == typeof mlvedaload && mlvedaload();
                try {
                    "object" == typeof DoublyGlobalCurrency && "function" == typeof DoublyGlobalCurrency.convertAll && DoublyGlobalCurrency.convertAll(jQueryGrizzly("[name=doubly-currencies]").val())
                } catch (t) {
                    console.log(t)
                }
            }

            function showVolDiscounts(info) {
                if (info.discount_table && info.discount_table.automatic_type) {
                    var templateVariables = {
                        product_message: info.offer_product_message || window.appikonDiscount.settings.dp.vd_product_message,
                        vol_rows: info.vol_rows
                    }

                    if (info.discount_table.automatic_type === "DEFAULT") {
                        var discountTiersTemplate = $("#adp-discount-tiers-default").html();
                    } else if (info.discount_table.automatic_type === "DETAILED") {
                        var discountTiersTemplate = $("#adp-discount-tiers-detailed").html();
                    } else if (info.discount_table.automatic_type === "GRID_RANGE") {
                        var discountTiersTemplate = $("#adp-discount-tiers-grid").html();
                    } else if (info.discount_table.automatic_type === "GRID_RANGE_ALT") {
                        var discountTiersTemplate = $("#adp-discount-tiers-grid-alt").html();
                    }

                    var volDiscountHtml = appikonHandlebars.compile(discountTiersTemplate)(templateVariables);
                    $("div.adp-vol-wrapper").html(volDiscountHtml);
                }
            }

            function showBuyXDiscounts(info) {
                var discountTiersTemplate = $("#adp-buy-x-discount-tiers").html(),
                        templateVariables = {
                            product_message: info.offer_product_message || window.appikonDiscount.settings.dp.vd_product_message,
                            vol_rows: info.vol_rows
                        },
                        buyXDiscountHtml = appikonHandlebars.compile(discountTiersTemplate)(templateVariables);
                $("div.adp-vol-wrapper").html(buyXDiscountHtml);
            }

            function appikonDelegate(discountResponse) {
                if (discountResponse.vol_rows) {
                    window.appikon.vol_rows = discountResponse.vol_rows;
                }

                if (discountResponse.discount_table && discountResponse.discount_table.type === "CUSTOM" && discountResponse.discount_table.html) {
                    let elements = [];
                    let found = false;

                    let foundGeneric = $(".shopacado-discount-table-container");
                    if (foundGeneric.length > 0) {
                        found = true;
                        elements.push(foundGeneric);
                    }

                    if (discountResponse.discount_table.placement_selector) {
                        let foundElements = $(discountResponse.discount_table.placement_selector);
                        if (foundElements.length > 0) {
                            found = true;
                            for(var j=0; j<foundElements.length; j++){
                                var element = foundElements.eq(j);
                                elements.push(element);
                            }
                        }
                    }

                    if (!found) {
                        let e = $("form[action*='/cart/add']").first();
                        elements.push(e);
                    }
                    for (let i = 0; i < elements.length; i++) {
                        let element = elements[i];

                        let wrapper = "<div class='adp-vol-wrapper'></div>";
                        if (discountResponse.discount_table.placement_position == 'BEFORE') {
                            element.before(wrapper);
                        } else {
                            element.after(wrapper);
                        }
                    }
                    $("div.adp-vol-wrapper").html(discountResponse.discount_table.html);
                } else if (discountResponse.discount_table && discountResponse.discount_table.type === "AUTOMATIC") {
                    if (discountResponse.vol_rows && discountResponse.vol_rows.length > 0 && ("buy_x_dollars" == discountResponse.type || "vd" == discountResponse.type) && window.appikonDiscount.settings.dp.show_vol_discount_table) {
                        var e;
                        if (window.appikonDiscount.settings.vd_placement_settings.hasOwnProperty("final_selector")) {
                            e = $(window.appikonDiscount.settings.vd_placement_settings.final_selector).first();
                            if (0 === e.length) {
                                e = $("form[action*='/cart/add']").first();
                            }
                        } else {
                            e = $("form[action*='/cart/add']").first();
                        }
                        if (0 === $(".adp-vol-wrapper").length) {
                            window.appikonDiscount.settings.vd_placement_settings.hasOwnProperty("placement") && "before" == window.appikonDiscount.settings.vd_placement_settings.placement ? e.before("<div class='adp-vol-wrapper'></div>") : e.after("<div class='adp-vol-wrapper'></div>");
                        }
                        "buy_x_dollars" === discountResponse.type ? showBuyXDiscounts(discountResponse) : showVolDiscounts(discountResponse);
                    }
                }

                var objectExists = function (t) {
                    return "object" == typeof t ? t : null
                };
                if (objectExists(discountResponse.discounts)) {
                    if(isAppikonProductPage && discountResponse.product_notification) {
                        showAppikonNotification(discountResponse.product_notification);
                    } else if(isAppikonCartPage && discountResponse.notifications && discountResponse.notifications.length) {
                        showAppikonNotification(discountResponse.notifications[0]);
                    }

                    if (objectExists(discountResponse.discounts.cart) && objectExists(discountResponse.discounts.cart.items)) {
                        showCartDiscounts(discountResponse.discounts);
                    }
                }

                if (discountResponse.product_lowest_price_message &&
                    window.appikonDiscount.settings.product_page_price_selector &&
                    window.appikonDiscount.settings.product_page_price_selector !== "") {
                    $(window.appikonDiscount.settings.product_page_price_selector).replaceWith("<span>" + discountResponse.product_lowest_price_message + "</span>");
                }

                reloadCurrency()

                if (window.appikon.postDiscountHandlers) {
                    for (let i = 0; i < window.appikon.postDiscountHandlers.length; i++) {
                        window.appikon.postDiscountHandlers[i](discountResponse);
                    }
                }
            }

            function getCheckoutSelectors() {
                var checkoutSelectors = window.appikonDiscount.settings.global.appikonCheckoutSelector.split(",");

                if(window.appikonDiscount.settings.checkout_selector) {
                    window.appikonDiscount.settings.checkout_selector.split(",").forEach(function(selector){
                        checkoutSelectors.push(selector);
                    });
                }

                return checkoutSelectors;
            }

            function checkoutEventHandler(t) {
                t.preventDefault();
                try {
                    DiscountedPricingCheckout(t)
                } catch (e) {
                    window.location = "/checkout"
                }
            }

            function showCartDiscounts(t) {
                window.appikon.discounts = t;
                for (var e = 0; e < t.cart.items.length; e++) {
                    var n = t.cart.items[e];

                    n.upsell_note = n.upsell_note ? n.upsell_note : "";
                    n.success_note = n.success_note ? n.success_note : "";

                    if (n.discounted_price < n.original_price) {
                        if (window.appikonDiscount.settings.use_compare_at_price === true) {
                            $(".appikon-cart-item-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.compare_at_price_format + "</span><span class='discounted_price '>" + n.discounted_price_format + "</span>");
                            $(".appikon-cart-item-line-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.compare_at_line_price_format + "</span><span class='discounted_price '>" + n.discounted_line_price_format + "</span>");
                            $(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.compare_at_price_format + "</span><span class='discounted_price '>" + n.discounted_price_format + "</span>");
                        } else {
                            $(".appikon-cart-item-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.original_price_format + "</span><span class='discounted_price '>" + n.discounted_price_format + "</span>");
                            $(".appikon-cart-item-line-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.original_line_price_format + "</span><span class='discounted_price '>" + n.discounted_line_price_format + "</span>");
                            $(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html("<span class='original_price '>" + n.original_price_format + "</span><span class='discounted_price '>" + n.discounted_price_format + "</span>");
                        }
                        $("span.discounted_price").css("font-weight", "bold");
                    } else {
                        if (window.appikonDiscount.settings.use_compare_at_price === true) {
                            $(".appikon-cart-item-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.compare_at_price_format + "</span>");
                            $(".appikon-cart-item-line-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.compare_at_line_price_format + "</span>");
                            $(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.compare_at_price_format + "</span>");
                        } else {
                            $(".appikon-cart-item-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.original_price_format + "</span>");
                            $(".appikon-cart-item-line-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.original_line_price_format + "</span>");
                            $(".appikon-cart-item-unit-price[data-key='" + n.key + "']").html("<span class='discounted_price appkion_original_price'>" + n.original_price_format + "</span>");
                        }
                        $("span.discounted_price").css("font-weight", "normal");
                    }

                    $(".appikon-cart-item-upsell-notes[data-key='" + n.key + "']").html(n.upsell_note);
                    $(".appikon-cart-item-success-notes[data-key='" + n.key + "']").html(n.success_note);
                }

                if ("string" == typeof t.discounted_price_html) {
                    if (window.appikonDiscount.settings.hide_paypal) {
                        $(".additional_checkout_buttons,.additional-checkout-button,.additional-checkout-buttons, .extra-checkout-buttons, .dynamic-checkout__content,.cart__additional_checkout, .cart-checkout-additional, #dynamic-checkout-cart").hide(), addGlobalStyle(".additional_checkout_buttons, .additional-checkout-button, .additional-checkout-buttons  {display:none !important;}");
                    }

                    if (t.positive_discount) {
                        displayCartTotals(t);
                    }

                    if (t.zero_discount_only || 0 == window.appikon.cart.total_price) {
                        $('form[action*="/cart"]').append("<input type='hidden' value='1' name='attributes[adp_identifier]'>");
                        try {
                            window.appikon.cart.attributes.adp_identifier = 1
                        } catch (o) {
                        }
                        // remove event checkout listeners if no discounts
                        var checkoutSelectors = getCheckoutSelectors();
                        checkoutSelectors.forEach(function (t) {
                            t = t.trim();
                            var e = document.querySelectorAll(t);
                            if ("object" == typeof e && e)
                                for (var n = 0; n < e.length; n++) {
                                    var o = e[n];
                                    if ("function" != typeof o.addEventListener) return;
                                    o.removeEventListener("click", checkoutEventHandler, false);
                                }
                        })
                    } else {

                        var checkoutSelectors = getCheckoutSelectors();

                        checkoutSelectors.forEach(function (t) {
                            t = t.trim();
                            var e = document.querySelectorAll(t);
                            if ("object" == typeof e && e)
                                for (var n = 0; n < e.length; n++) {
                                    var o = e[n];
                                    if ("function" != typeof o.addEventListener) return;
                                    o.addEventListener("click", checkoutEventHandler, false);
                                }
                        })
                    }
                    $(".wholesale-cart-total").css("font-weight", "bold");
                   // $("span.wholesale-original-cart-total").css("display", "block");
                } else {
                    if (window.appikonDiscount.settings.use_compare_at_price === true) {
                        $(".wholesale-cart-total").html("<span class=''>" + t.compare_at_price_html + "</span>");
                    } else {
                        $(".wholesale-cart-total").html("<span class=''>" + t.original_price_html + "</span>");
                    }
                    $("span.wholesale-original-cart-total").css("display", "none");
                    $(".wholesale-cart-total").css("font-weight", "normal");

                    // remove event checkout listeners if no discounts
                    var checkoutSelectors = getCheckoutSelectors();
                    checkoutSelectors.forEach(function (t) {
                        t = t.trim();
                        var e = document.querySelectorAll(t);
                        if ("object" == typeof e && e)
                            for (var n = 0; n < e.length; n++) {
                                var o = e[n];
                                if ("function" != typeof o.addEventListener) return;
                                o.removeEventListener("click", checkoutEventHandler, false);
                            }
                    })
                }
            }

            function showDiscountCodeInput(selector, index, array) {
                let discountCodeWrapper = "<div class='appikon-discounts-wrapper'>" +
                                              "<input type='text' id='appikon-discount-code' placeholder='Discount Code'>" +
                                              "<button id='apply-appikon-discount' class='btn btn--secondary'>Apply</button>" +
                                          "</div>"

                if (window.appikonDiscount.settings.discount_code_settings.inputPlacementPosition === "BEFORE") {
                    $(selector).before(discountCodeWrapper);
                } else if (window.appikonDiscount.settings.discount_code_settings.inputPlacementPosition === "AFTER") {
                    $(selector).after(discountCodeWrapper);
                } else if (window.appikonDiscount.settings.discount_code_settings.inputPlacementPosition === "PREPEND") {
                    $(selector).prepend(discountCodeWrapper);
                } else if (window.appikonDiscount.settings.discount_code_settings.inputPlacementPosition === "APPEND") {
                    $(selector).append(discountCodeWrapper);
                } else if (window.appikonDiscount.settings.discount_code_settings.inputPlacementPosition === "REPLACE") {
                    $(selector).after(discountCodeWrapper);
                    $(selector).hide();
                }
            }

            function displayCartTotals(t) {
                $(".wholesale-original-cart-total span.wholesale-original-price").length > 0 ? $(".wholesale-original-cart-total span.wholesale-original-price").css("text-decoration", "line-through") : $(".wholesale-original-cart-total").css("text-decoration", "line-through");
                $(".wholesale-original-cart-total").show()

                if (window.appikonDiscount.settings.use_compare_at_price === true) {
                    $("span.wholesale-original-price").html(t.compare_at_price_html);
                } else {
                    $("span.wholesale-original-price").html(t.original_price_html);
                }

                $(".wholesale-cart-total").html("<span class=''>" + t.discounted_price_html + "</span>");
                var e = "";
                if (t.summary_item_html) {
                    e = t.summary_item_html;
                }

                $(".subtotal .cart_savings.sale").hide();
                $(".wholesale-cart-total").prepend("<span class='appikon-messages'><div id='appikon-summary-item'>" + e + "</div><div id='appikon-discount-item'></div></span>");
                if (window.appikonDiscount.settings.show_discount_code) {
                    $('.appikon-discounts-wrapper').remove();

                    var discountCodePlacementSelectors = window.appikonDiscount.settings.discount_code_settings.inputPlacementSelector.split(',');
                    discountCodePlacementSelectors.forEach(showDiscountCodeInput);

                    if (window.appikon.discount_code) {
                        $(".appikon-discounts-wrapper").hide();
                        $("div[id=appikon-discount-item]").html('<button id="appikon-remove-discount-code" type="button">X</button>' + t.discount_item_html);

                        document.querySelectorAll("#appikon-remove-discount-code").forEach(item => {
                            item.addEventListener('click', event => {
                                deleteCookie("appikon_discount_" + window.appikonDiscount.settings.shop);
                                delete window.appikon.discount_code;
                                triggerDiscountCalculation();
                            })
                        });
                    } else {
                        $(".appikon-discounts-wrapper").show();
                    }

                }

                $(".wholesale-cart-total span").css("text-decoration", "none");
                reloadCurrency();
            }

            function showAppikonNotificatioBar(notificationMessage, selector, placement) {
                if(notificationMessage && notificationMessage.trim()) {
                    var notificationBarElement = "<div id='appikon-notification-bar'><div id='appikon-close-notification'>X</div>" + notificationMessage.trim() + "</div>"
                    // Remove old notification
                    $('#appikon-notification-bar').remove()

                    if(selector) {
                        var selectorElement = $(selector).first();
                        if(selectorElement.length){
                            "before" == placement.toLowerCase() ? selectorElement.before(notificationBarElement) : selectorElement.after(notificationBarElement)
                        }
                    } else {
                        window.appikonDiscount.settings.global.headerSelector.split(",").forEach(function (t) {
                            t = $.trim(t)
                            "#shopify-section-header" == t ? $(t).after(notificationBarElement) : "main" == t ? $(t).prepend(notificationBarElement) : $(t).before(notificationBarElement)
                        })
                    }

                    $("#appikon-notification-bar").length > 0 && $("#appikon-notification-bar").show()
                }
            }

            function showAppikonNotification(notificationMessage) {
                // Show product page Notification
                if(isAppikonProductPage && window.appikonDiscount.settings.show_product_notification_bar) {
                    showAppikonNotificatioBar(notificationMessage,
                        window.appikonDiscount.settings.notification_placement_settings.final_selector,
                        window.appikonDiscount.settings.notification_placement_settings.placement)
                }

                if(isAppikonCartPage && window.appikonDiscount.settings.show_cart_notification_bar) {
                    showAppikonNotificatioBar(notificationMessage,
                        window.appikonDiscount.settings.notification_cart_placement_settings.final_selector,
                        window.appikonDiscount.settings.notification_cart_placement_settings.placement)
                }
            }

            function checkTermsAccepted () {
                if (window.appikonDiscount.settings.turn_off_agree_checkbox) {
                    return true;
                }

                if (window.appikonDiscount.settings.terms_selector) {
                    let customSelectors = window.appikonDiscount.settings.terms_selector.split(',');
                    for (let i = 0; i < customSelectors.length; i++) {
                        let termsSelector = "input[type='checkbox']" + customSelectors[i];
                        let termsSelectorChecked = "input[type='checkbox']" + customSelectors[i] + ":checked";

                        if ($(termsSelector).length > 0 && $(termsSelectorChecked).length === 0) {
                            return false;
                        }
                    }
                } else {
                    let termsSelector = "input[type='checkbox']#agree";
                    let termsSelectorChecked = "input[type='checkbox']#agree:checked";

                    if ($(termsSelector).length > 0 && $(termsSelectorChecked).length === 0) {
                        return false;
                    }
                }

                return true;
            }

            function DiscountedPricingCheckout(t) {
                if (checkTermsAccepted()) {
                    $(t.target).prop("disabled", "disabled");

                    window.appikon.action_type = "checkout";
                    var i = [],
                            a = [];
                    $("[name^='attributes']").each(function () {
                        var t = $(this),
                                e = $(this).attr("name"),
                                n = {
                                    name: e = e.replace(/^attributes\[/i, "").replace(/\]$/i, ""),
                                    value: t.val()
                                };
                        if ("" != n.value) switch (t[0].tagName.toLowerCase()) {
                            case "input":
                                "checkbox" == t.attr("type") ? t.is(":checked") && a.push(n) : a.push(n);
                                break;
                            default:
                                a.push(n)
                        }
                    });
                    var r = "";
                    if (window.Shopify.locale) {
                        i.push("locale=" + window.Shopify.locale);
                    }
                    $("[name='note']").length && (r = $("[name='note']")[0].value), window.appikon.cart.note_attributes = a, window.appikon.cart.note = r, r.length && i.push("note=" + encodeURIComponent(r)), a.length && a.map(function (t) {
                        i.push("attributes" + encodeURIComponent("[" + t.name + "]") + "=" + encodeURIComponent(t.value))
                    }), $.ajax({
                        cache: !1,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        type: "POST",
                        url: window.appikonDiscount.settings.app_root_url,
                        data: JSON.stringify(window.appikon),
                        success: function (t) {
                            t.invoice_url ? (i.length && (t.invoice_url += "?" + i.join("&")),
                                                setTimeout(function () {
                                                    window.location.href = t.invoice_url
                                                }, 500)
                                            ) : (
                                                t.invoice_url = "/checkout",
                                                t.discount_code && (setCookie("adp-pr-id", t.pr_id, 14), i.push("discount=" + t.discount_code)),
                                                i.length && (t.invoice_url += "?" + i.join("&")),
                                                window.location.href = t.invoice_url
                                            )
                        },
                        error: function () {
                            window.location.href = "/checkout"
                        }
                    })
                }
            }

            function notifyCalculationsInProgress() {
                return hasFlag("notify_about_disocunt_calculations") && (hasFlag("disable_checkout_button") ? (checkoutBtn.attr("disabled", !0).val("Please wait").text("Please wait").css("border-color", originalBorder).css("background-color", originalBackground), setTimeout(enableCheckoutButton, 4e3)) : isAppikonCartPage && showAppikonNotification(window.appikonDiscount.settings.calculation_note, {})), !0
            }

            function hideCalculationsInProgressNote() {
                return hasFlag("notify_about_disocunt_calculations") && (hasFlag("disable_checkout_button") ? enableCheckoutButton() : $("#appikon-notification-bar").text() == window.appikonDiscount.settings.calculation_note + "X" && $("#appikon-notification-bar").fadeOut("slow")), !0
            }

            function getRefreshDelayValue() {
                var t = "";
                return t = isMobileBrowser() ? window.appikonDiscount.settings.buyx.delay_mobile_refresh_cart : window.appikonDiscount.settings.buyx.delay_refresh_cart, 1e3 * parseFloat(t)
            }

            function disableCheckoutButtons() {
                var checkoutSelectors = getCheckoutSelectors();
                $.each(checkoutSelectors, function(index, selector){
                    $(selector).prop('disabled', true);
                });
            }

            function enableCheckoutButtons() {
                var checkoutSelectors = getCheckoutSelectors();
                $.each(checkoutSelectors, function(index, selector){
                    $(selector).prop('disabled', false);
                });
            }

            function checkForTestOffer() {
                window.appikon.test_offer_token = getCookie('shopacado-test-offer-token');
                window.appikon.test_offer_name = getCookie('shopacado-test-offer-name');
                console.log("testing offer: " + getCookie('shopacado-test-offer-name'));

                if (window.appikon.test_offer_token && window.appikon.test_offer_token != "") {
                    showTestOfferNotice();
                }
            }

            function showTestOfferNotice() {
                var noticeHtml = `
                    <div id="shopacado-banner">
                        <div id="shopacado-banner-content">
                            Testing Offer: ` + window.appikon.test_offer_name + `
                            <button id="shopacado-stop-test-offer">Stop Testing</button>
                        </div>
                    </div>
                `;
                $("#shopacado-banner").remove();
                $("body").prepend(noticeHtml);
                $("body").addClass("push-down");
                $("#shopacado-stop-test-offer").click( function () {
                    removeTestOfferNotice();
                });
            }

            function removeTestOfferNotice() {
                $("#shopacado-banner").remove();
                $("body").removeClass("push-down");
                deleteCookie("shopacado-test-offer-token");
                deleteCookie("shopacado-test-offer-name");
                delete window.appikon.test_offer_token;
                delete window.appikon.test_offer_name;
            }

            function calculateAppikonDiscount() {
                disableCheckoutButtons();

                var xhrAppikonDiscountRequest = $.ajax({
                    cache: !1,
                    type: "POST",
                    url: window.appikonDiscount.settings.app_root_url,
                    data: JSON.stringify(window.appikon),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8"
                }).done(function(data) {

                    window.appikonResponseStore.discountResponse = data;

                    fillCartData(true);
                    enableCheckoutButtons();

                }).fail(function(jqXHR, status, error) {
                    console.error("calculateAppikonDiscount", error, jqXHR.responseText)
                    enableCheckoutButtons();
                })
            }

            function prepareAppikonDiscountRequestData(appikonDrawerCart) {
                window.appikon.cart = appikonDrawerCart;
                window.appikon.adp_page = 'cart';

                window.appikon.discounts = {};
                window.appikon.cart_product_ids = [];

                appikonDrawerCart.items.forEach(function(item){
                    var appikon_item = item;
                    ["product_title", "total_discount", "discounts", "grams", "vendor", "taxable", "gift_card", "url", "image", "featured_image", "requires_shipping", "product_type", "product_description", "variant_title", "variant_options"].map(function(k) {
                        delete appikon_item[k]
                    });

                    window.appikon.cart_product_ids.push(appikon_item.product_id);
                });


                if(window.appikon.cart.items.length > 0) {
                    // Get Product Metadata
                    var xhrAppiconCartViewJSONRequet = $.ajax({
                        cache: !1,
                        type: "GET",
                        url: "/cart?view=appikon.json",
                        dataType: "text",
                        beforeSend: function(xhr){xhr.setRequestHeader('x-requested-with', '');}
                    }).done(function(data) {

                        var cartMetadataResponse = JSON.parse(data)

                        window.appikon.cart_collection_ids = [];

                        window.appikon.cart.items.forEach(function(item){

                            cartMetadataResponse.items.forEach(function(cartMetadataItem){
                                if(cartMetadataItem.id == item.id) {
                                    item["collection_ids"] = cartMetadataItem.collectionIds;
                                }
                            });

                            window.appikon.cart_collection_ids.push(item.collection_ids);
                        });

                        calculateAppikonDiscount();

                    }).fail(function(jqXHR, status, error) {
                        console.error("prepareAppikonDiscountRequestData", error, jqXHR.responseText)
                    })
                }
            }

            function isCartChange(newCart) {

                var isCartChange = false;

                var oldCart = window.appikonResponseStore.cartJS;

                var cartPropertiesToCompare = ["original_total_price", "total_discount", "total_weight", "item_count", "items_subtotal_price"];

                $.each(cartPropertiesToCompare, function (i, prop) {
                    if (oldCart[prop] !== newCart[prop]) {
                        isCartChange = true;
                        return false; // break the loop
                    }
                });

                if(!isCartChange && oldCart.items.length !== newCart.items.length) {
                    isCartChange = true;
                }

                if(!isCartChange) {
                    $.each(oldCart.items, function(i, oldItem){
                        var newItem = newCart.items[i];
                        if(oldItem.id !== newItem.id || oldItem.quantity !== newItem.quantity) {
                            isCartChange = true;
                            return false; // break the loop
                        }
                    })
                }

                return isCartChange;
            }

            function triggerDiscountCalculation() {
                if (window.appikonResponseStore.cartJS) {
                    prepareAppikonDiscountRequestData(window.appikonResponseStore.cartJS);
                } else {
                    getAppikonDiscontData();
                }
            }

            function processCartData(ajaxCartData) {
                if (isCartChange(ajaxCartData)) {
                    window.appikonResponseStore.cartJS = ajaxCartData;
                    prepareAppikonDiscountRequestData(ajaxCartData)
                } else {
                    fillCartData();
                }
            }

            async function addCompareAtPrice(cart) {
                var totalCompareAtPrice = 0;
                await Promise.all(cart.items.map(async (item) => {
                    $.ajax({
                        url: '/products/' + item.handle + '.js',
                        dataType: 'json',
                        async: false,
                        success: function(product){
                            for (const variant of product.variants) {
                                item["compare_at_price"] = item["price"];
                                if (variant.id == item.variant_id && variant.compare_at_price != null) {
                                    item["compare_at_price"] = variant.compare_at_price;
                                    break;
                                }
                            };
                            const compareAtLinePrice = item["compare_at_price"] * item["quantity"];
                            totalCompareAtPrice += compareAtLinePrice;
                            item["compare_at_line_price"] = compareAtLinePrice;
                        }
                    });
                }));

                cart.compare_at_total_price = totalCompareAtPrice;

                return cart;
            }

            function getAppikonDiscontData() {
                if (window.appikonDiscount.settings.use_compare_at_price === true){
                    var xhrAppiconCartRequet = $.ajax({
                        cache: !1,
                        type: "GET",
                        url: "/cart.js",
                        dataType : "json"
                    }).done(async function(ajaxCartData) {
                        let cartWithCompareAt = await addCompareAtPrice(ajaxCartData);
                        processCartData(cartWithCompareAt);
                    }).fail(function(jqXHR, status, error) {
                        console.error("getAppikonDiscontData", error, jqXHR.responseText)
                    })

                }else{
                    var xhrAppiconCartRequet = $.ajax({
                        cache: !1,
                        type: "GET",
                        url: "/cart.js",
                        dataType : "json"
                    }).done(function(ajaxCartData) {
                        processCartData(ajaxCartData);
                    }).fail(function(jqXHR, status, error) {
                        console.error("getAppikonDiscontData", error, jqXHR.responseText)
                    })
                }
            }
            window.appikon.calculateDiscounts = getAppikonDiscontData;

            function insertCartTitleSnippet(productTitleSelector) {

                var isInserted = false;

                if (!productTitleSelector) {
                    return isInserted;
                }

                var selectors = productTitleSelector.split(",");

                $.each(selectors, function(index, selector) {
                    var elems = $(selector);

                    if (elems.length) {
                        var cart = window.appikon.cart;
                        elems.each(function (index) {
                            if (index < cart.items.length && $(this).find(".appikon-cart-item-success-notes").length === 0) {

                                $(this).html($(this).html() + "<span class='appikon-cart-item-success-notes' data-key='" + cart.items[index].key + "'></span><span class='appikon-cart-item-upsell-notes' data-key='" + cart.items[index].key + "'></span>");

                                isInserted = true;
                            }
                        });
                    }

                })

                return isInserted;
            }

            function insertCartLinePriceSnippet(cartLinePriceSelector) {

                var isInserted = false;

                if (!cartLinePriceSelector) {
                    return isInserted;
                }

                var selectors = cartLinePriceSelector.split(",");

                $.each(selectors, function(index, selector) {
                    var elems = $(selector);

                    if (elems.length) {
                        var cart = window.appikon.cart;
                        elems.each(function (index) {
                            if (index < cart.items.length && $(this).find(".appikon-cart-item-line-price").length == 0) {
                                $(this).html("<span class='appikon-cart-item-line-price' data-key='" + cart.items[index].key + "'>" +
                                        $(this).html() + "</span>");

                                isInserted = true;
                            }
                        });
                    }

                })

                return isInserted;
            }

            function insertCartUnitPriceSnippet(cartUnitPriceSelector) {

                var isInserted = false;

                if (!cartUnitPriceSelector) {
                    return isInserted;
                }

                var selectors = cartUnitPriceSelector.split(",");

                $.each(selectors, function(index, selector) {
                    var elems = $(selector);

                    if (elems.length) {
                        var cart = window.appikon.cart;
                        elems.each(function (index) {
                            if (index < cart.items.length && $(this).find(".appikon-cart-item-unit-price").length == 0) {
                                $(this).html("<span class='appikon-cart-item-unit-price' data-key='" + cart.items[index].key + "'>" + $(this).html() + "</span>");
                            }
                        });
                    }

                })

                return isInserted;
            }

            function insertCartSubTotalSnippet(cartSubTotalSelector) {

                var isInserted = false;

                if (cartSubTotalSelector) {
                    var selectors = cartSubTotalSelector.split(",");

                    $.each(selectors, function(index, selector) {
                        var elem = $(selector).eq(0);

                        if(elem && elem.length && elem.find(".wholesale-original-cart-total").length == 0) {
                            elem.html("<span class='wholesale-original-cart-total'>" +
                                        "<span class='wholesale-original-price'>" + elem.html() + "</span>" +
                                        "</span>" +
                                        "<span class='wholesale-cart-total'></span>" +
                                        "<div class='additional-notes'>" +
                                        "<span class='wholesale-minimums-note'></span>" +
                                        "<span class='wholesale-extra-note'></span>" +
                                        "</div>");

                            isInserted = true;
                        }

                    })

                }

                return isInserted;
            }

            function insertCartSnippets(cartType) {
                var productTitleInserted = null;
                var linePriceInserted = null;
                var subtotalInserted = null;
                var unitPriceInserted = null;

                if (cartType === 'DRAWER') {
                    productTitleInserted = insertCartTitleSnippet(window.appikonDiscount.settings.drawer_cart_product_title_selector);
                    linePriceInserted = insertCartLinePriceSnippet(window.appikonDiscount.settings.drawer_cart_line_price_selector);
                    unitPriceInserted = insertCartUnitPriceSnippet(window.appikonDiscount.settings.drawer_cart_unit_price_selector);
                    subtotalInserted = insertCartSubTotalSnippet(window.appikonDiscount.settings.drawer_cart_sub_total_selector);
                } else if (cartType === 'REGULAR') {
                    productTitleInserted = insertCartTitleSnippet(window.appikonDiscount.settings.regular_cart_product_title_selector);
                    linePriceInserted = insertCartLinePriceSnippet(window.appikonDiscount.settings.regular_cart_line_price_selector);
                    unitPriceInserted = insertCartUnitPriceSnippet(window.appikonDiscount.settings.regular_cart_unit_price_selector);
                    subtotalInserted = insertCartSubTotalSnippet(window.appikonDiscount.settings.regular_cart_sub_total_selector);
                }

                return productTitleInserted || linePriceInserted || subtotalInserted || unitPriceInserted;
            }

            function fillCartData(forceFill) {
                setTimeout(function() {
                    if(window.appikonResponseStore.discountResponse) {
                        var drawerCartSnippets = insertCartSnippets("DRAWER");
                        var regularCartSnippets = false;
                        if (window.appikonDiscount.settings.is_dynamic_insertion) {
                            regularCartSnippets = insertCartSnippets("REGULAR");
                        }

                        if(drawerCartSnippets || regularCartSnippets || forceFill == true) {
                            appikonDelegate(window.appikonResponseStore.discountResponse);
                        }
                    }
                }, 400);
            }

            function refreshAppikonData() {
                getAppikonDiscontData();
            }

            function handleCartRequests(url) {

                var isCartRequestProcessed = true;

                if ((url.includes('/cart.js')
                    || url.includes('/cart.json')
                    || url.includes('/cart/add.js')
                    || url.includes('/cart/update.js')
                    || (window.appikonDiscount.settings.is_dynamic_insertion && url.includes('/cart/change'))
                    || url.includes('/cart/clear.js')
                    || url.endsWith('/cart')
                    || url.includes('/cart?'))
                    && !url.includes('/cart?view=appikon.json')) {

                    if (url.includes('/cart/add.js') || url.endsWith('/cart') || url.includes('/cart?') ) {
                        $.ajax({
                            cache: !1,
                            type: "GET",
                            url: "/cart.js",
                            dataType: "json"
                        }).done(function (ajaxCartData) {
                            //processCartData(ajaxCartData);
                        }).fail(function (jqXHR, status, error) {
                            console.error(error)
                        })
                    } else {
                        isCartRequestProcessed = false;
                    }
                }

                return isCartRequestProcessed;

            }

            $(document).ready(function () {
                if(window.appikonDiscount.settings.dp.installed) {
                    refreshAppikonData();

                    if (window.appikonDiscount.settings.listen_to_ajax_cart_events_strategy) {
                        // Intercept AJAX requests
                        var origOpen = window.XMLHttpRequest.prototype.open;
                        window.XMLHttpRequest.prototype.open = function() {
                            this.addEventListener('load', async function() {
                                var url = this.responseURL;
                                if(!handleCartRequests(url)) {
                                    var ajaxCartData = JSON.parse(this.responseText);
                                    if (window.appikonDiscount.settings.use_compare_at_price === true) {
                                        var cartWithCompareAt = await addCompareAtPrice(ajaxCartData);
                                        processCartData(cartWithCompareAt);
                                    } else {
                                        processCartData(ajaxCartData);
                                    }
                                }
                            });
                            origOpen.apply(this, arguments);
                        };

                        // Intercept fetch requests
                        const originalFetch = window.fetch;
                        window.fetch = function() {
                            return new Promise((resolve, reject) => {
                                originalFetch.apply(this, arguments)
                                        .then((response) => {
                                            var url = response.url;

                                            if(!handleCartRequests(url)) {

                                                $.ajax({
                                                    cache: !1,
                                                    type: "GET",
                                                    url: "/cart.js",
                                                    dataType: "json"
                                                })
                                                // response.clone().json().then(ajaxCartData  => {
                                                //   processCartData(ajaxCartData);
                                                //});
                                            }

                                            resolve(response);
                                        })
                                        .catch((error) => {
                                            reject(response);
                                        })
                            });
                        }

                    } else {
                        var appikonCallRepeater = setInterval(refreshAppikonData,1000);
                    }
                }
            });

            var appikonCookieCode = getCookie("appikon_discount_" + window.appikonDiscount.settings.shop);
            appikonCookieCode && (window.appikon.discount_code = appikonCookieCode);

            if (hasFlag("disable_checkout_button")) {
                var checkoutBtn = $(window.appikonDiscount.settings.global.appikonCheckoutSelector);
                var originalCheckoutContent = checkoutBtn.val() || checkoutBtn.html();
                var originalBorder = checkoutBtn.css("border-color");
                var originalBackground = checkoutBtn.css("background-color");
                var enableCheckoutButton = function () {
                    checkoutBtn.html(originalCheckoutContent).val(originalCheckoutContent).removeAttr("disabled").removeAttr("border-color").removeAttr("background-color")
                };
            }
            if (isAppikonCartPage) {
                var skipIds = getCookie("adp-skip-ids");
                skipIds && (window.appikon.skip_ids = skipIds)
            }

            window.appikon.multicurrency = {};
            if (window.Shopify && window.Shopify.currency) {
                window.appikon.multicurrency.currency = window.Shopify.currency.active;
                window.appikon.multicurrency.rate = window.Shopify.currency.rate;
            }
            if (window.theme && window.theme.moneyFormat) {
                window.appikon.multicurrency.moneyFormat = window.theme.moneyFormat;
            } else if (window.theme && window.theme.strings && window.theme.strings.moneyFormat) {
                window.appikon.multicurrency.moneyFormat = window.theme.strings.moneyFormat;
            } else if (window.Theme && window.Theme.strings && window.Theme.strings.moneyFormat) {
                window.appikon.multicurrency.moneyFormat = window.Theme.strings.moneyFormat;
            } else if (window.Theme && window.Theme.moneyFormat) {
                window.appikon.multicurrency.moneyFormat = window.Theme.moneyFormat;
            } else if (window.mwSwitcherObjects && window.mwSwitcherObjects.shop.money_format){
                window.appikon.multicurrency.moneyFormat = window.mwSwitcherObjects.shop.money_format;
            }

            window.appikon.adp_page.length && window.appikonDiscount.settings.dp.installed > 0 && ($.ajax({
                cache: !1,
                type: "POST",
                url: window.appikonDiscount.settings.app_root_url,
                data: JSON.stringify(window.appikon),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function (t) {
                    appikonDelegate(t);
                }
            })), setTimeout(function () {
                "function" == typeof ga && ga(function (t) {
                    window.gaclientId = t.get("clientId")
                })
            }, 1e3), hasFlag("refresh_on_qty_plush_minus") && ($(document).on("click", window.appikonDiscount.settings.plus_minus_qty_selector, function () {
                var t = this;
                isAppikonCartPage && setTimeout(function () {
                    $(t).parents('form[action*="/cart"]').submit()
                }, 500)
            }), hasFlag("refresh_on_qty_change_hard") && (window.appikon.cartSubmit = function () {
                isAppikonCartPage && setTimeout(function () {
                    $('form[action*="/cart"]').submit()
                }, 500)
            }, $(document).ready(function () {
                setTimeout(function () {
                    var t, e = document.querySelectorAll(window.appikonDiscount.settings.plus_minus_qty_selector);
                    for (t = 0; t < e.length; t++) e[t].setAttribute("onclick", "window.appikon.cartSubmit();")
                }, 1200)


            })));
            var debutEditBtnExists = $("div.cart__edit button.btn.cart__edit--active:visible").length > 0,
                    qtyInputEvent = debutEditBtnExists ? "" : "input ";
            if (isAppikonCartPage && $(document).on(qtyInputEvent + "change", "input.appikon-quantity, input[name^='updates['], input[id^='updates_'], input[id^='Updates_']", function (t) {
                var e = this;
                t.preventDefault(), "" != $.trim($(this).val()) && (setTimeout(function () {
                    hasFlag("quantities_refresh_over_submit") ? window.location.reload() : $(e).parents('form[action*="/cart"]').submit()
                }, getRefreshDelayValue()))
            }), isAppikonCartPage && ($(document).on("click", "td.cart-qty span.icon-plus, td.cart-qty span.icon-minus", function (t) {
                t.preventDefault(), $(this).parents('form[action*="/cart"]').submit()
            }), !window.appikonDiscount.settings.is_dynamic_insertion && $(document).ajaxSuccess(function (t, e, n) {
                n && "/cart/change.js" == n.url && window.location.reload()
            }), 1 != hasFlag("avoid_default_qty_input_event_change") && (setTimeout(function () {
                $(".js-qty__adjust").off("click")
            }, 500), $(document).on("click", "div.js-qty .js-qty__adjust", function (t) {
                if(!window.appikonDiscount.settings.avoid_cart_quantity_adjustment) {
                    t.preventDefault();
                    var e = parseInt($(this).parents("div.js-qty").find("input").val());
                    if ($(this).hasClass("js-qty__adjust--plus")) var n = e + 1;
                    else n = e - 1;
                    $(this).parents("div.js-qty").find("input").val(n).change()
                } else {
                    $(this).parents("div.js-qty").find("input").change()
                }
            }))), $(document).on("click", "button#apply-appikon-discount", function (t) {
                t.preventDefault();
                var discount_code_entered = $("input[id=appikon-discount-code]:visible").val().trim();
                setCookieMinutes("appikon_discount_" + window.appikonDiscount.settings.shop, discount_code_entered, 5);
                window.appikon.discount_code = discount_code_entered;
                triggerDiscountCalculation();
            }), $(document).on("click", "div#appikon-close-notification", function (t) {
                t.preventDefault(), setCookie("appikon_notifications_closed", 1, .01), $("#appikon-notification-bar").slideUp("slow")
            }), $(document).on("click", ".appikon-variants-container select.adp-variants", function () {
                $(this).children("option").length < 1 && alert("All item variants are out of stock")
            }), hasFlag("use_google_fonts")) {
                function insertGoogleFontStyle(t) {
                    var e = document.head,
                            n = document.createElement("link");
                    n.id = "adp_google_fonts_link", n.type = "text/css", n.rel = "stylesheet", n.href = "https://fonts.googleapis.com/css?family=" + t.join(","), e.appendChild(n)
                }
            };

            
        });
    }(window, document);


